import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import BlockRounded from "@mui/icons-material/BlockRounded";
import useEnhancedNavigate from "./Session/helpers";
import { logClickEvent } from "../analytics";
import { BASE_PROMPTS_PER_DAY } from "./Plans/bundleCatalogue";

// replaces the message input once the daily quota is exhausted.
const PromptLimitLock = ({ dailyPrompts }: { dailyPrompts?: number }) => {
  const navigate = useEnhancedNavigate();
  const limit = dailyPrompts && dailyPrompts > 0 ? dailyPrompts : BASE_PROMPTS_PER_DAY;
  const earned = Math.max(limit - BASE_PROMPTS_PER_DAY, 0);

  return (
    <div className="flex flex-col items-center gap-2 py-8 text-center">
      <div className="w-16 h-16 rounded-full bg-gray-100 dark:bg-mui-white-12 flex items-center justify-center mb-1">
        <BlockRounded className="!w-7 !h-7 text-mui-black-60 dark:text-mui-white-56" />
      </div>
      <Typography variant="h6/medium-500" component="h2">
        You’ve used all your prompts for today
      </Typography>
      <Typography variant="body2/regular-400" className="text-mui-black-60 dark:text-mui-white-56">
        Your plan includes
        {" "}
        {limit}
        {" "}
        prompts/day (
        {BASE_PROMPTS_PER_DAY}
        {" "}
        base
        {earned > 0 ? ` + ${earned} earned` : ""}
        ).
        <br />
        Add bundles to earn more.
      </Typography>
      <Button
        variant="contained"
        onClick={() => {
          logClickEvent("prompt_limit_add_bundles_click");
          navigate("/plans");
        }}
        className="!bg-black dark:!bg-white !text-white dark:!text-mui-black-87 !normal-case !px-6 !py-2 !mt-2 !font-semibold"
      >
        Add bundles
      </Button>
    </div>
  );
};

export default PromptLimitLock;
